import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
            <div className="pq-section pq-style-1 text-center">
              <span className="pq-section-sub-title">FAQs</span>
              <h2 className="pq-section-title">Frequently Asked Question</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "How is a neck swelling diagnosed?", answer: "Doctors may recommend an ultrasound, CT scan, MRI or fine needle aspiration (FNAC) to find the reason behind the swelling. These tests help determine whether it’s an infection, cyst, or tumor." },
                  { question: "When is surgery required for neck swelling?", answer: "Surgery is needed if the swelling is due to a cyst, thyroid nodule, or tumor that doesn’t respond to medicines. The procedure removes the affected tissue safely to prevent further complications." },
                  { question: "Is neck swelling surgery safe and painless?", answer: "Yes, it’s a safe procedure done under anesthesia, so there’s no pain during surgery. Some mild discomfort or tightness may be felt afterward, but it improves quickly with medication and rest." },
                  { question: "How long does it take to recover after neck surgery?", answer: "Most patients recover within 1–2 weeks depending on the type of surgery. Light activities can resume in a few days, while complete healing and normal movement follow soon after." },
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
